import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { Tooltip } from '@ukpostbox/frontend-framework';
import { SignUpGenericSectionInterface } from '../../Types/SignUp/SignUpSection';
import { SignUpPlanType } from '../../Types/SignUp/SignUpPlan';
import SignUpSectionHeader from '../SignUpSectionHeader';
import { SignUpPerkType } from '../../Types/SignUp/SignUpPerk';
import { SelectPlan } from '../SelectPlanButton';

function SignUpComparison(props: SignUpGenericSectionInterface) {
	const HandleEditCallback = () => {
		if (props.onEditCallback) {
			props.onEditCallback();
		}
	};

	const HandleCallBack = (itemProps: any) => {
		if (props.value === itemProps.id) {
			if (props.onCancelCallback) {
				props.onCancelCallback();
			}
		} else if (props.onChangeCallback) {
			props.onChangeCallback(itemProps);
		}
	};

	return (
		<div
			className={`sign-up-section ${props.visible ? 'mb-xxxl' : 'sign-up-section-hide'} ${props.complete && !props.visible ? 'sign-up-section-complete mt-xs' : 'mt-lg'}`}
		>
			<SignUpSectionHeader
				label={props.label}
				completeLabel={props.completeLabel}
				complete={props.complete}
				visible={props.visible}
				editCallBack={() => HandleEditCallback()}
			/>

			{props.visible && (
				<div className='plan-comparison-wrapper'>
					<div className='flex-row flex-gap-sm plan-comparison-row plan-comparison-row-header'>
						<h5 className='m-0'>Address</h5>
						{props.plansOverview.map((plan: SignUpPlanType, index: number) => {
							if (!plan.enabled) return null;

							return (
								<div>
									<h5 className='m-0 text-center'>{plan.label}</h5>
								</div>
							);
						})}
					</div>

					<div className='flex-row flex-gap-sm plan-comparison-row plan-comparison-price-row'>
						<h5 className='m-0'>-</h5>
						{props.plansOverview.map((plan: SignUpPlanType) => {
							if (!plan.enabled) return null;

							return (
								<div>
									<div className='pricing-block-price-info text-center'>
										<div className='pricing-block-price'>£{plan.cost} </div>
										<small className='fade'>
											{plan.variablePrice ? 'minimum' : ''} per month, inc VAT*
										</small>
									</div>
								</div>
							);
						})}
					</div>

					{props.planPerks.map((perk: SignUpPerkType) => (
						<div className='flex-row flex-gap-sm plan-comparison-row'>
							<div>{perk.label}</div>
							{props.plansOverview.map((plan: SignUpPlanType) => {
								if (!plan.perks.includes(perk.id)) return <div />;

								return (
									<div className='flex-row flex-gap-sm justify-center align-center'>
										<div className='pricing-block-perk-icon pricing-block-perk-included text-center'>
											<FontAwesomeIcon icon={faCheckCircle} />
										</div>
										{plan.tips && plan.tips.includes(perk.id) && (
											<div className='pricing-block-perk-tip mr-n-xl'>
												<Tooltip content='Available on selected addresses and locations' />
											</div>
										)}
									</div>
								);
							})}
						</div>
					))}

					<div className='flex-row flex-gap-sm plan-comparison-row plan-comparison-footer'>
						<h5 className='m-0'>-</h5>
						{props.plansOverview.map((plan: SignUpPlanType) => {
							if (!plan.enabled) return null;

							return <SelectPlan parentProps={props} itemProps={plan} />;
						})}
					</div>

					<small>
						*If you’re outside of the UK and operate as an Incorporated Business or Registered Charity, you
						won’t be charged VAT.
					</small>
				</div>
			)}
		</div>
	);
}

export default SignUpComparison;
